import { MenuItem, TextField } from '@mui/material';

import type { PeriodWindow } from '~/components/serviceHistory/periodWindow';
import { periodWindowOptions } from '~/components/serviceHistory/periodWindow';

/** Which months the grid below covers. Shared by both service-history sub-tabs. */
export function PeriodSelect({
  window,
  onWindowChange,
}: {
  window: PeriodWindow;
  onWindowChange: (next: PeriodWindow) => void;
}) {
  return (
    <TextField
      select
      size="small"
      label="Period"
      value={window}
      onChange={(event) => onWindowChange(event.target.value as PeriodWindow)}
      sx={{ minWidth: 190, alignSelf: 'flex-start' }}
    >
      {periodWindowOptions().map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
